import { render, staticRenderFns } from "./MobilePhoneInput.vue?vue&type=template&id=86cccfe2&scoped=true"
import script from "./MobilePhoneInput.vue?vue&type=script&lang=js"
export * from "./MobilePhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cccfe2",
  null
  
)

export default component.exports